import { borderRadiusBySize, borderStyles, iconFillColors } from './constants';

interface GetBorderClassesInput {
    size: DropdownSize;
    borderConfig: DropdownBorderConfig;
}

export const getBorderClasses = ({
    size,
    borderConfig,
}: GetBorderClassesInput): string => {
    switch (borderConfig) {
        case 'none':
            return '';

        case 'from-size':
            if (size === 'small') {
                return borderRadiusBySize[size];
            }

            return `${borderRadiusBySize[size]} ${borderStyles[size]}`;

        case 'transparent.small':
            return 'rounded';

        case 'solid.small':
            return `${borderStyles.small} rounded`;

        case 'transparent.medium':
            return 'rounded-md';

        case 'solid.medium':
            return `${borderStyles.medium} rounded-md`;

        case 'transparent.large':
            return 'rounded-lg';

        case 'solid.large':
            return `${borderStyles.large} rounded-lg`;

        default:
            return '';
    }
};

interface GetIconFillColorInput {
    disabled: boolean;
    size: DropdownSize;
}

export const getIconFillColor = ({
    disabled,
    size,
}: GetIconFillColorInput): string => {
    if (disabled) {
        return iconFillColors.disabled;
    }

    return iconFillColors[size];
};
